/* eslint-disable camelcase */

import type { ApiBaseResponse } from '@hotjar/webapp/domains/common/api';
import { mapResponseErrorToMessage } from '@hotjar/webapp/domains/common/api';
import type {
  Targeting,
  CreateAppStateReqest,
  GetAppStateResponse,
  AppStateSettings,
  AppState,
  ScopedKeyValue,
} from './types';

export const mapToCreateAppStateRequest = (
  scopedKeyValue: ScopedKeyValue,
  targeting?: Targeting,
): CreateAppStateReqest => {
  return {
    namespace: scopedKeyValue.namespace,
    key: scopedKeyValue.key,
    value: scopedKeyValue.value || null,
    account_id: targeting?.accountId || null,
    organization_id: targeting?.organizationId || null,
    site_id: targeting?.siteId || null,
  };
};

export function mapFromApiBaseResponse<T extends ApiBaseResponse>(res: T): T {
  if (res.success) {
    return <T>res;
  }
  throw new Error(`Failed to fetch app-state. Reason = ${mapResponseErrorToMessage(res?.error)}`);
}

export const mapToAppStateSettings =
  (targeting?: Targeting) =>
  (res: GetAppStateResponse): AppStateSettings => {
    let settings = res.success && res.app_state_settings ? res.app_state_settings : [];
    if (targeting && settings.length > 0) {
      settings = targeting?.siteId
        ? settings.filter((setting) => setting.site_id === targeting.siteId)
        : settings;
      settings = targeting?.accountId
        ? settings.filter((setting) => setting.account_id === targeting.accountId)
        : settings;
      settings = targeting?.organizationId
        ? settings.filter((setting) => setting.organization_id === targeting.organizationId)
        : settings;
    }

    return settings.reduce<AppStateSettings>(
      (settingsMap: AppStateSettings, curr: AppState): AppStateSettings => {
        const { namespace, key, value } = curr;
        const settingsPerNamespace = settingsMap[namespace] || {};
        return {
          ...settingsMap,
          [namespace]: {
            ...settingsPerNamespace,
            [key]: value,
          },
        } as AppStateSettings;
      },
      {},
    );
  };
